import React from 'react'

import { ButtonClean, useModalContext } from '@fourthwall/components'

import { isPaidTier } from '../../../../utils'
import { useTierContext } from '../../hooks/useTierContext'
import { CurrenciesUpdateModal } from '../CurrenciesUpdateModal'

export const UpdateCurrencyConversion = () => {
  const modal = useModalContext()

  const { tier, form, enabledCurrencies, isPriceRatesLoading, updateCurrencyConversion } =
    useTierContext()

  if (!tier) return null
  if (!isPaidTier(tier)) return null
  if (!enabledCurrencies) return null

  return (
    <ButtonClean
      label="Update currency conversion"
      withUnderline
      appearance="secondary"
      disabled={tier.statistics.membersCount > 0 || isPriceRatesLoading}
      onClick={() => {
        modal.open(CurrenciesUpdateModal, {
          price: form.values.price,
          enabledCurrencies,
          tier,
          onSave: updateCurrencyConversion,
        })
      }}
    />
  )
}
